var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.456 32H6.81a2.795 2.795 0 01-2.795-2.795V9.172a1.035 1.035 0 012.07 0v20.033a.725.725 0 00.725.725h18.635a.725.725 0 00.724-.725V2.795a.725.725 0 00-.724-.724H12.608a1.035 1.035 0 110-2.071h12.848a2.795 2.795 0 012.795 2.795v26.41A2.795 2.795 0 0125.456 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.568 10.352H5.32a1.335 1.335 0 01-.932-2.277L11.636.414a1.336 1.336 0 011.429-.321 1.325 1.325 0 01.838 1.232v7.66a1.337 1.337 0 01-1.335 1.367zm-5.446-2.07h4.71V3.199l-4.71 5.083zM21.719 14.245h-11.17a1.035 1.035 0 110-2.07h11.17a1.036 1.036 0 010 2.07zM21.719 8.655h-4.462a1.035 1.035 0 010-2.07h4.462a1.035 1.035 0 010 2.07zM21.719 19.825h-11.17a1.036 1.036 0 010-2.07h11.17a1.035 1.035 0 110 2.07zM21.719 25.405h-11.17a1.035 1.035 0 010-2.07h11.17a1.035 1.035 0 010 2.07z"
  })));
}

export default SvgApply;